import { render, staticRenderFns } from "./CreateReward.vue?vue&type=template&id=a9c51f66&scoped=true&"
import script from "./CreateReward.vue?vue&type=script&lang=js&"
export * from "./CreateReward.vue?vue&type=script&lang=js&"
import style0 from "./CreateReward.vue?vue&type=style&index=0&id=a9c51f66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c51f66",
  null
  
)

export default component.exports